
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jTJ2Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $933959fea935b6ae$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $933959fea935b6ae$export$2e2bcd8739ae039 = {
    'fabric.editor.headingLink.ascSortingLabel': 'crescente',
    'fabric.editor.headingLink.copied': 'Copiato.',
    'fabric.editor.headingLink.copyAnchorLink': "Copia link nell'intestazione",
    'fabric.editor.headingLink.copyAriaLabel': 'Copia',
    'fabric.editor.headingLink.descSortingLabel': 'decrescente',
    'fabric.editor.headingLink.failedToCopy': 'Copia non riuscita',
    'fabric.editor.headingLink.noneSortingLabel': 'nessuno',
    'fabric.editor.inlineComment.marker.end': 'fine del commento in linea',
    'fabric.editor.inlineComment.marker.start': 'inizio del commento in linea'
};

});


//# sourceMappingURL=it.e96a32e3.js.map
